<template>
  <div>
    <Toolbar :handle-back="() => back()" :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('process_edit')"  class="nobackground" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-book</v-icon>
            <!--
            <span v-if="item.type">
              <span v-if="language == 'fr'">{{ item.type.namefr }}</span>
              <span v-else>{{ item.type.name }}</span> - 
            </span>
            -->

            <span>
              <span v-if="language == 'fr'">{{ item.namefr }}</span>
              <span v-else>{{ item.name }}</span>
            </span>
          </h1>
        </v-toolbar-title>
        <v-btn icon 
                      @click.stop="exportProcess(item)"
                    >
                      <v-icon>mdi-export</v-icon>
                    </v-btn>
      </template>
      <template slot="right">
        <v-btn
          v-if="userHasAccess('step_edit')"
          class="ml-sm-2"
          color="primary"
          @click="addStep"
        >
          {{ $t('global.add')}} {{ $t('process.step')}}
        </v-btn>
      </template>
    </Toolbar>
    <br />
    <div v-if="item" class="table-process-show">

      <v-carousel id="carouselStep" class="nobackground" v-model="stepCurrent" min-height="400" height="100%" :continuous="false" show-arrows hide-delimiters hide-delimiter-background progress="primary" horizontal-delimiters="top">
        <v-carousel-item
          v-for="(step, i) in steps"
          :key="step.id"
          :value="i"
        >
          <StepCard
              ref="StepCard"
              :values="step"
              :process="item"
              :isZoom="isZoom"
              :zoom="zoomCarousel"
            />  
        </v-carousel-item>
      </v-carousel>
      <v-container>
        <v-row>
          <v-col cols="12" sm="4" md="4">                                   
            <v-img class = "ma-2" max-height="250" max-width="250" lazy-src="@/assets/imagenotfound.png" :key="getItemImageKey(item)" :src="getImageUrlByObject(item)" >
              <ImageForm ref="updateForm" :item="item" v-if="userHasAccess('process_edit')" />
                <v-btn color="secondary" small absolute bottom right @click="downloadItem()">
                  <v-icon>mdi-download-circle</v-icon>
                </v-btn>
            </v-img>
          </v-col>
          <v-col cols="12" sm="8" md="8">
            <div class="text-h5 primary--text mr-10" >
              <span>{{$t('global.number')}}{{ item['number'] }} - </span>
              <span v-if="language == 'fr'">{{ item.namefr }}</span>
              <span v-else>{{ item.name }}</span>
            </div>
            <div >
              <span class="tablehtmleditor" v-if="language == 'fr'" v-html="item.descriptionfr"></span>
              <span class="tablehtmleditor" v-else v-html="item.description"></span>
            </div>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <span v-for="(product, index) in item['valueType']" :key="product" class="text-rightfont-weight-bold white--text familyGothamPro" >
                  <span v-if="index > 0">/</span>
                  {{ product }}
                </span>
              </v-col>
            </v-row>
            <v-card-actions class="bordertop_white pl-0 ml-0">
                    <span class="mr-1">{{$t('process.intensity')}}:</span>
                    <v-tooltip bottom >
                      <template v-slot:activator="{ on, attrs }" >
                        <span   v-bind="attrs" v-on="on" class="d-inline-flex">
                          <v-sheet color="primary" outlined class="mr-1" height="10" width="10" ></v-sheet>
                          <v-sheet v-if="item.intensity >= 2 " color="primary" outlined class="ml-1 mr-1" height="10" width="10" ></v-sheet>
                          <v-sheet v-else color="secondary" outlined class="ml-1 mr-1" height="10" width="10" ></v-sheet>
                          <v-sheet v-if="item.intensity >= 3 " color="primary" outlined class="ml-1 mr-1" height="10" width="10" ></v-sheet>
                          <v-sheet v-else color="secondary" outlined class="ml-1 mr-1" height="10" width="10" ></v-sheet>
                        </span>
                      </template>
                      <span>{{$t('process.intensity')}}</span>
                    </v-tooltip >
                    
                    
                    <v-tooltip bottom >
                      <template v-slot:activator="{ on, attrs }" >
                        <span   v-bind="attrs" v-on="on" class="d-inline-flex">
                          <v-icon class="ml-6 mr-1">mdi-clock</v-icon> {{ displayTime(item.time * 60) }}
                        </span>
                      </template>
                      <span>{{$t('process.time')}}</span>
                    </v-tooltip>                  
            </v-card-actions>
          </v-col>
        </v-row>
      </v-container>
      <v-expansion-panels accordion>
      <v-expansion-panel>
        <v-expansion-panel-header>{{$t('global.explore')}}</v-expansion-panel-header>
        <v-expansion-panel-content>
 
          <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('global.number') }}</strong></td>
              <td>
                  {{ item['number'] }}
              </td>
              <td></td>
              <td>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('global.name') }}</strong></td>
              <td>
                  {{ item['name'] }}
              </td>
              <td><strong>{{ $t('global.namefr') }}</strong></td>
              <td>
                  {{ item['namefr'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('global.description') }}</strong></td>
              <td>
                  {{ item['description'] }}
              </td>
              <td><strong>{{ $t('global.descriptionfr') }}</strong></td>
              <td>
                  {{ item['descriptionfr'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('global.type') }}</strong></td>
              <td>
                  <ul>
                    <li v-for="_type in item['types']" :key="_type.id">
                      {{ _type.name }}
                    </li>
                  </ul>
                </td>
              <td><strong>{{ $t('global.updated') }}</strong></td>
              <td>
                {{ formatDateTime(item['updated'], 'long') }}
              </td>

            </tr>
            <tr>
              <td><strong>{{ $t('global.enabled') }}</strong></td>
              <td>
                  {{ item['enabled'] }}
              </td>
              <td><strong>{{ $t('global.hub') }}</strong></td>
              <td>
                  {{ item['public'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('process.time') }}</strong></td>
              <td>
                  {{ item['time'] }}
              </td>
              <td><strong>{{ $t('process.intensity') }}</strong></td>
              <td>
                  {{ item['intensity'] }} -
                  <span v-if="item['intensity'] == 1">{{ $t('global.easy') }}</span>
                  <span v-if="item['intensity'] == 2">{{ $t('global.normal') }}</span>
                  <span v-if="item['intensity'] == 3">{{ $t('global.hard') }}</span>
              </td>
            </tr>
            <tr>

              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>{{ $t('menu.product') }}</td>
              <td>
                <ul v-for="(object, attr) in item['valueType']" :key="attr">
                  <li>
                    <span >{{ object }}</span>
                  </li>
                </ul>
              </td>
              <td><strong>{{ $t('qualitycheck.customer.customers') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['customers']" :key="_item.id">
                    {{ _item.name }}
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('process.defaultprocessmachine') }}</strong></td>
              <td>
                  {{ item['defaultProcess'] }}
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td><strong>{{ $t('process.category') }}</strong></td>
              <td v-if="item['category']">
                  {{ item['category'].name }}
              </td>
              <td><strong>{{ $t('process.fixtureRef') }}</strong></td>
              <td v-if="item['fixtureRef']">
                  {{ item['fixtureRef'] }}
              </td>
            </tr>
            

          </tbody>
        </template>
      </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
     
    </div>
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import i18n from '../../i18n.js';
import { displayTime } from '../../utils/dates';
import { mapActions, mapState, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import ImageForm from '../../components/ImageForm.vue';
import FileMixin from '../../mixins/FileMixin';
import Toolbar from '../../components/Toolbar';
import StepCard  from '../../components/step/StepCard';

const servicePrefix = 'Process';

export default {
  name: 'ProcessShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ImageForm,
      StepCard
  },
  data() {
    return {
      filter: '250x250',
      stepCurrent: 0,
      datazoom: false,
      stepData: null,
    }
  },
  mixins: [ShowMixin,AccessMixin,FileMixin],
  mounted() {
  
   this.stepGetSelectItems( { 'params': { 'process'  : this.$route.params.id, 'order[number]'  : 'asc'} ,'data': ('step' + this.$route.params.id) });
  },
  computed: {
    isLoading() {
      return (
        this.isLoading_process ||
        this.isLoading_step
       );
    },
    ...mapFields('process', {
      isLoading_process: 'isLoading'
    }),
    ...mapFields('step', {
      isLoading_step : 'isLoading'
    }),
    ...mapState('step', {
      updatedata: 'updatedata',
    }),
    ...mapGetters('step',{
      dataStep: 'data',
    }),
    ...mapGetters('process', ['find']),
    steps: {
      get() { return this.stepData },
       set(value) { this.stepData = value; }
    },
    language() {
      return i18n.locale;
    },
    isZoom() {
      if(this.datazoom) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions({
      processActionDownload: 'process/actionDownload',
    }),
    exportProcess(process){
      let id = process['id'];
      let route = 'exportprocess/' + id;
        this.processActionDownload({action: route,name: 'exportprocess', values: {}});
    },
    ...mapActions({
      stepGetSelectItems: 'step/fetchAllData',
      
    }),
    ...mapActions('process', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),
    displayTime,
    addStep() {
       this.$router.push({ name: `StepCreate` , params: { parent: this.item['@id'] }});
    },
    zoomCarousel() {
      if (document.fullscreenElement) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          this.datazoom = false;
        }
      } else {
        var elem = document.getElementById("carouselStep");
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
          this.datazoom = true;
        }
      }


    },
    back() {
      this.$router.back();
    },
  },
  watch: {
    updatedata(updatedata) {
      if (updatedata == ('step' + this.$route.params.id)) {
        this.steps = this.dataStep(('step' + this.$route.params.id));
      }
    },
  }
};
</script>
<style>
.v-carousel__controls {
  top: 0px;
}
.v-carousel__progress {
  top: 0px;
}
.btn_carroussel {
  margin-bottom: 10px;
}
.v-window__controls {
  align-items: flex-end;
}
</style>